import { render, staticRenderFns } from "./dr-list-view.vue?vue&type=template&id=420c6c32&"
import script from "./dr-list-view.vue?vue&type=script&lang=js&"
export * from "./dr-list-view.vue?vue&type=script&lang=js&"
import style0 from "./dr-list-view.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports